/**
 * Tour route map canvas — phone, tablet, and editorial web share one product.
 *
 * The photo cover is the cinematic strip (`tourDetailCoverMaxHeight`). The
 * map is a real itinerary section, not a 16:9 splash of that cover and not a
 * dead preview. Phone gets a short but usable canvas; tablet / two-column
 * editorial gets a taller one so numbered stops stay readable.
 *
 * Height is chosen from editorial + two-column, never from large-web-only
 * desktop shell mode. Native phones and tablets must still get a map.
 */
export const TOUR_MAP_FIT_PADDING = 44
export const TOUR_MAP_HEIGHT_PHONE = 280
export const TOUR_MAP_HEIGHT_TABLET = 360
export const TOUR_MAP_HEIGHT_EDITORIAL = 400

export function tourMapCanvasHeight(input: { editorial: boolean; twoColumn: boolean }): number {
  if (input.twoColumn) return TOUR_MAP_HEIGHT_EDITORIAL
  if (input.editorial) return TOUR_MAP_HEIGHT_TABLET
  return TOUR_MAP_HEIGHT_PHONE
}

export function isTourMapLayoutReady(size: { width: number; height: number } | null): boolean {
  return Boolean(size && size.width > 0 && size.height > 0)
}
